import React from "react";
import { ScrollArea } from "../ui/scroll-area";
import { Card, CardContent } from "../ui/card";

/**
 * Read-only list of credit transactions. Pure render-from-array — no fetching
 * inside the component so the parent stays the source of truth.
 */
const TransactionsTab = ({ transactions }) => (
  <Card className="bg-gray-900 border-gray-800">
    <CardContent className="p-4 sm:p-6">
      <h3 className="text-white text-base sm:text-lg font-semibold mb-4">Transaction History</h3>
      <ScrollArea className="h-[300px] sm:h-[400px]">
        {transactions.length > 0 ? (
          <div className="space-y-3 sm:space-y-4">
            {transactions.map((t) => {
              // For Stripe USD refunds (commission cancel), the credit amount is
              // zero — show the dollar refund instead so users see the real value.
              const showUsdRefund = t.type === "commission_cancel_refund" && t.refund_usd > 0;
              return (
                <div key={t.id} className="flex items-center justify-between py-2 border-b border-gray-800" data-testid={`transaction-${t.id}`}>
                  <div className="flex-1 min-w-0 mr-2">
                    <p className="text-white text-xs sm:text-sm truncate">{t.description}</p>
                    <p className="text-gray-500 text-[10px] sm:text-xs">{new Date(t.created_at).toLocaleString()}</p>
                  </div>
                  {showUsdRefund ? (
                    <span className="font-semibold text-sm sm:text-base whitespace-nowrap text-amber-300" title="Stripe USD refund">
                      ${t.refund_usd.toFixed(2)} refunded
                    </span>
                  ) : (
                    <span className={`font-semibold text-sm sm:text-base whitespace-nowrap ${t.amount >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                      {t.amount >= 0 ? '+' : ''}{t.amount.toFixed(2)}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-gray-400 text-center py-8 text-sm">No transactions yet</p>
        )}
      </ScrollArea>
    </CardContent>
  </Card>
);

export default TransactionsTab;
